export default {}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js